// 引入路由
import { constantRoutes, asyncRoutes } from "../../router/index";
const state = {
  routes: [], //获取全部路由
  addRoutes: []
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  }
};

const actions = {
  generateRoutes({ commit }) {
    let accessedRoutes = asyncRoutes || [];
    commit("SET_ROUTES", accessedRoutes);
  }
};

export default {
  state,
  mutations,
  actions
};
